/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_DescriptionInputs */

const en_ledger_query_description = /** @type {(inputs: Ledger_Query_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes apply to the next Load accounts or Refresh for every dossier using this template. Separate column names with commas.`)
};

const nl_ledger_query_description = /** @type {(inputs: Ledger_Query_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen gelden bij de volgende keer laden of vernieuwen voor alle dossiers met dit sjabloon. Scheid kolomnamen met komma’s.`)
};

/**
* | output |
* | --- |
* | "Changes apply to the next Load accounts or Refresh for every dossier using this template. Separate column names with commas." |
*
* @param {Ledger_Query_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_description = /** @type {((inputs?: Ledger_Query_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_description(inputs)
	return en_ledger_query_description(inputs)
});